import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FiArrowLeft, FiEdit2, FiTrash2 } from 'react-icons/fi';
import Card from '../Components/Card';
import DataTable from '../Components/DataTable';
import { useDraftList, useDeleteDraft } from '../hooks/useDrafts';
import { getDraft } from '../Api/draftsApi';
import { formatDate } from '../utils/format';

// kind = 'retailer' | 'checkin'
const CFG = {
  retailer: { po: 'SFMACUCM', heading: 'Retailer drafts', back: '/retailers' },
  checkin: { po: 'SFVMCKPI', heading: 'Check-in drafts', back: '/checkins' },
};

export default function DraftsListPage({ kind = 'retailer' }) {
  const navigate = useNavigate();
  const cfg = CFG[kind] || CFG.retailer;
  const { data: rows, isLoading } = useDraftList(cfg.po);
  const del = useDeleteDraft();

  const resume = async (guid) => {
    if (kind === 'checkin') {
      // need the retailer guid from the payload to open its check-in screen
      try {
        const d = await getDraft(guid);
        const cm = JSON.parse(d?.payloadJson || '{}')?.retailerCmGuid;
        navigate(cm ? `/retailers/${cm}/checkin?draft=${guid}` : '/checkins');
      } catch { navigate('/checkins'); }
    } else {
      navigate(`/retailers/new?draft=${guid}`);
    }
  };

  const columns = [
    { key: 'title', header: 'Draft', render: (r) => r.title || <span className="hrms-muted">(untitled)</span> },
    { key: 'savedDate', header: 'Saved', width: 140, render: (r) => formatDate(r.savedDate) },
  ];

  return (
    <div className="hrms-page">
      <div className="hrms-toolbar">
        <h1 className="hrms-page-title">{cfg.heading}</h1>
        <Button variant="light" onClick={() => navigate(cfg.back)}><FiArrowLeft className="me-1" /> Back</Button>
      </div>
      <Card>
        <DataTable
          columns={columns}
          rows={rows}
          loading={isLoading}
          rowKey="mavroFormDraftGuid"
          emptyMessage="No saved drafts."
          rowActions={(row) => (
            <>
              <Button size="sm" variant="light" title="Resume" onClick={() => resume(row.mavroFormDraftGuid)}><FiEdit2 /></Button>
              <Button size="sm" variant="light" title="Discard" onClick={() => del.mutate(row.mavroFormDraftGuid)}><FiTrash2 /></Button>
            </>
          )}
        />
      </Card>
    </div>
  );
}
